import { Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import FirstImage from '../../resource/icon-png/first-pic.png';
import SecondImage from '../../resource/icon-png/second-pic.png';
import ThirdImage from '../../resource/icon-png/third-pic.png';
import IF from '../IF';
import './index.less';

interface IProps {
    visible: boolean
    onCancel: () => void,
    onOk: () => void,
}

// eslint-disable-next-line max-len
const firstStepString = 'The Syngenta Soil Data is a repository for storage of soil sample analysis generated internally. Soil profiles can be established for open field or greenhouse and shared internally for potential reuse.';
// eslint-disable-next-line max-len
const secondStepString = 'The Syngenta Soil Data is a repository for storage of soil sample analysis generated internally. Soil profiles can be established for open field or greenhouse and shared internally for potential reuse.';
const thirdStepString = 'We already have data on 18,000 soil profiles from all continents in our database. You can see them on the map as green pins.';
const thirdStepTitle = 'What next?';
export default function HelpCarousel(props: IProps) {
    const {
        visible,
        onCancel,
        onOk
    } = props;
    const [currentIndex, setCurrentIndex] = useState(1);

    const handleNextButtonClick = () => {
        if (currentIndex % 3 === 0 && currentIndex > 0) {
            onCancel();
            setCurrentIndex(1);
        } else {
            setCurrentIndex(currentIndex % 3 + 1);
        }
    };

    useEffect(() => {
        console.log(currentIndex);
    }, [currentIndex]);

    return (
        <Modal
            open={visible}
            onCancel={onCancel}
            onOk={onOk}
            title={null}
            footer={
                <div className='footer-button'>
                    <IF show={currentIndex !==3}>
                        <button className='first-button' onClick={onCancel}>
                            Skip
                        </button>
                    </IF>
                    <button className='second-button' onClick={handleNextButtonClick}>
                        { currentIndex !== 3 ? 'Next' : 'Finish'}
                    </button>
                </div>}
            className='carousel-modal'
            closeIcon={<span />}
        >
            <div>
                <img src={currentIndex === 1 ? FirstImage : currentIndex === 2 ? SecondImage : ThirdImage} className='image-step' />
            </div>
            <div className='carousel-index'>
                <button className={`${currentIndex === 1 ? 'currentBackColor' : null}`} />
                <button className={`${currentIndex === 2 ? 'currentBackColor' : null}`} />
                <button className={`${currentIndex === 3 ? 'currentBackColor' : null}`} />
            </div>
            <div className='step-detail-div'>
                <h4 className='title-indicate'>{ currentIndex === 3 ? thirdStepTitle : 'Welcome to Soil Analysis Tool !'}</h4>
                <span className='description-step'>
                    {currentIndex === 1 && firstStepString}
                    {currentIndex === 2 && secondStepString}
                    {currentIndex === 3 && thirdStepString}
                </span>
            </div>
        </Modal>
    );
}
